module.exports = __webpack_public_path__ + "img/zte.1ac324a0.svg";